import { useNavigate } from "react-router-dom";
import HorizontalRule from "../HorizontalRule/HorizontalRule";



export function PropDisplay({ prop, value }: { prop: string, value: string}) {
    
   

    return (
    <>
        <div className="w-full flex justify-between my-2">
            <div className="font-bold">{prop}:</div>
            <div>{value || '-'}</div>
        </div>
        <HorizontalRule />
    </>
)
}


type RoutableContent = {
    route: string,
    value: string
}


export function RoutableDisplay({ prop, values}: { prop: string, values: RoutableContent[]}) {
    
    const navigate= useNavigate();

    const displayComma = (idx : number) => {
        if (idx !== values.length -1) {
            return ', '
        }
        return ''
    } 

    return (
    <>
        <div className="w-full flex justify-between my-2">
            <div className="font-bold">{prop}:</div>
            <div className="flex ">
                {values.map((v: RoutableContent, idx:number) => <div className="cursor-pointer hover:underline mr-1" onClick={()=> navigate(v.route)}>{v.value}{displayComma(idx)}</div>)}
            </div>
           
        </div>
        <HorizontalRule />

        </>
    )
}